import React from 'react';
import HeroSection from './components/HeroSection';
import EmailVerificationSection from './components/EmailVerificationSection';
import WhatToExpectSection from './components/WhatToExpectSection';
import CTASection from './components/CTASection';

const NewsletterSubscriptionThankYouPage = () => {
  return (
    <div style={{ background: '#050A12', minHeight: '100vh' }}>
      <HeroSection />
      <EmailVerificationSection />
      <WhatToExpectSection />
      <CTASection />
    </div>
  );
};

export default NewsletterSubscriptionThankYouPage;
